export const prUrl = `https://mt.osintsee.com/?murl=`
// export const divUrl = 'https://www.osintsee.com/mortydiv?murl='
export const googleUrl = 'https://www.google.com.hk/search?hl=zh-CN&q='